import styled from 'styled-components';
import { SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150, getMargins } from '@oneaudi/unified-web-alpha-common';
import { IconButton } from '../icon-button/index.js';
import {} from './index.js';
export const StyledNavigationBar = styled.ul `
  margin: 0;
  padding: 0;
  display: flex;
  overflow-y: hidden;
  overflow-x: auto;
  scrollbar-width: none;
  flex-wrap: nowrap;

  &::-webkit-scrollbar {
    display: none;
  }
`;
export const StyledListItem = styled.li `
  list-style-type: none;
  flex: 1 0 auto;
  display: flex;
`;
export const StyledNavigationBarItemInner = styled.span `
  position: relative;
  align-items: center;
  display: flex;
  gap: ${(props) => props.size === 'sm' ? SYS_SPACE_FIXED_100 : SYS_SPACE_FIXED_150};
`;
export const StyledNavigationBarContainer = styled.nav `
  margin: ${(props) => getMargins(props.margin)};
  display: flex;
  align-items: center;
`;
export const StyledIconButton = styled(IconButton) `
  flex-shrink: 0;
`;
//# sourceMappingURL=index.styles.js.map